import Loadable from "react-loadable";

const LazyEvaluate = Loadable({
  loader: () => import(/* webpackChunkName: 'propale-evaluate' */ "./Evaluate"),
  loading: () => 'loading...'
});

export default LazyEvaluate;
